import Onboard from "./onboard";
import resetPassScreen from "./resetPassScreen";
import Welcome from "./welcome";

export default {
    Welcome: Welcome,
    Onboard,
    RestPassword: resetPassScreen
}